import React, { useState, useMemo, useEffect } from 'react';
import { Table, Form, Pagination } from 'react-bootstrap';
import { Predio, PrediosPrograma, turnoMap, UserByDistance } from '../../../../../../service/types/types';


interface PrediosProgramaRow extends Predio {
  user: UserByDistance;
}

type PredioTableProps = {
  predios: PrediosPrograma[];
  rowsPerPage?: number;
};

export default function ResumenPrograma({ predios }: PredioTableProps) {
  const [search, setSearch] = useState('');
  const [programaRow, setProgramaRow] = useState<PrediosProgramaRow[]>([]);
  useEffect(() => {
    const rows: PrediosProgramaRow[] = predios.flatMap(predio => {
      // Combina todos los arrays de usuarios en uno solo
      const allUsers: UserByDistance[] = [
        ...(predio.usersM ?? []),
        ...(predio.usersT ?? []),
        ...(predio.usersN ?? []),
      ];

      // Mapea cada usuario a la estructura de fila
      return allUsers.map(user => ({
        id: predio.id,
        name: predio.name,
        location: predio.location,
        user,
      }));
    });
    setProgramaRow(rows)
  }, [predios]);
  
  // Filtrar predios según búsqueda
  const filteredPredios = useMemo(() => {
    return programaRow.filter((p) =>
      [p.name, p.user.name, p.user.rut, p.user.localidad].some((field) =>
        field?.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [predios, search, programaRow]);

  return (
    <div>
      {/* 🔎 Buscador */}
      <Form.Control
        type="text"
        placeholder= {"Buscar"}
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
        }}
        className="mb-3"
      />

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Rut</th>
            <th>Trabajador</th>
            <th>Numero</th>
            <th>Localidad</th>
            <th>Turno</th>
          </tr>
        </thead>
        <tbody>
          {filteredPredios.map((predio) => (
              <tr key={predio.id + predio.user.rut}>
                <td>{predio.name}</td>  
                <td>{predio.user.rut}</td>  
                <td>{predio.user.name}</td>  
                <td>{predio.user.phone}</td>  
                <td>{predio.user.localidad}</td> 
                <td>{turnoMap[predio.user.turno] ?? predio.user.turno}</td>
              </tr>))}
        </tbody>
      </Table>
    </div>
  );
}